module.exports = __webpack_public_path__ + "img/Bitmap@2x123 (2).5e7079b4.png";